import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";
import TopicCard from "@/components/feature/TopicCard";
import type { Topic } from "@/types";

const latest: Topic[] = topics.slice(0, 6);

export default function LatestFeed() {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6 md:py-16">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            最新吃瓜话题
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            新话题持续更新，点开就能看到讨论区和瓜友观点。
          </p>
        </div>
        <Link
          to="/topics"
          className="whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          进入话题广场 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {latest.map((topic) => (
          <TopicCard key={topic.id} topic={topic} />
        ))}
      </div>
    </section>
  );
}